import { SimpleCardStackWrap, WrapCardText } from '@shared/components/core/card/CommonCardStyles';
import { HeaderSectionWrap, HeaderWrap } from '@shared/components/core/headers/HeaderWraps';
import Icons from '@shared/components/core/images/Icons';
import { TruncateTitleSmall } from '@shared/components/core/text/Typography';
import MemberEditAccess from '@shared/components/organization/member/MemberEditAccess';
import RoleIconList from '@shared/components/organization/role/RoleIconList';
import { roleIcons } from '@shared/constants/organization/RoleValues';
import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import OrganizationMemberModel from '@shared/models/organizations/OrganizationMemberModel';
import OrganizationMemberRole from '@shared/models/organizations/OrganizationMemberRole';
import { OrgContentWrap } from '../CommonOrgStyles';

interface IMemberCardProps {
    myRole: OrganizationMemberRole;
    member: OrganizationMemberModel;
    organizationId: string;
}

export default function MemberCardStack({ myRole, member, organizationId }: Readonly<IMemberCardProps>) {
    if (!member || !myRole.canViewMembers) return null;

    return (
        <SimpleCardStackWrap>
            <WrapCardText>
                <HeaderWrap>
                    <HeaderSectionWrap>
                        <Icons name={member.isAdmin ? roleIcons.isAdmin : 'user'} size={35} />
                        <TruncateTitleSmall>{member.user.email}</TruncateTitleSmall>
                    </HeaderSectionWrap>
                    <HeaderSectionWrap>
                        <MemberEditAccess myRole={myRole} member={member} organizationId={organizationId} />
                    </HeaderSectionWrap>
                </HeaderWrap>
                <OrgContentWrap>
                    <RoleIconList variant="listOnly" role={extractRoleProperties(member)} />
                </OrgContentWrap>
            </WrapCardText>
        </SimpleCardStackWrap>
    );
}
